import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=0c4d2e7c&scoped=true&"
import script from "./CustomerService.vue?vue&type=script&lang=js&"
export * from "./CustomerService.vue?vue&type=script&lang=js&"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=0c4d2e7c&lang=css&scoped=true&"
import style1 from "./CustomerService.vue?vue&type=style&index=1&id=0c4d2e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d2e7c",
  null
  
)

export default component.exports